namespace Gamification.Gamification {
    export interface ProdottiAziendeRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoAzienda?: number;
        IdProdotto?: number;
        IdAzienda?: number;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
        IdAziendaTenantId?: number;
        IdAziendaRagioneSociale?: string;
    }

    export namespace ProdottiAziendeRow {
        export const idProperty = 'IdProdottoAzienda';
        export const localTextPrefix = 'Gamification.ProdottiAziende';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoAzienda = "IdProdottoAzienda",
            IdProdotto = "IdProdotto",
            IdAzienda = "IdAzienda",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione",
            IdAziendaTenantId = "IdAziendaTenantId",
            IdAziendaRagioneSociale = "IdAziendaRagioneSociale"
        }
    }
}
